/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Negotiation_Signal_RemoteInputs */

const en_negotiation_signal_remote = /** @type {(inputs: Negotiation_Signal_RemoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remote`)
};

const de_negotiation_signal_remote = /** @type {(inputs: Negotiation_Signal_RemoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remote`)
};

const fr_negotiation_signal_remote = /** @type {(inputs: Negotiation_Signal_RemoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remote`)
};

const es_negotiation_signal_remote = /** @type {(inputs: Negotiation_Signal_RemoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remote`)
};

const it_negotiation_signal_remote = /** @type {(inputs: Negotiation_Signal_RemoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remote`)
};

const nl_negotiation_signal_remote = /** @type {(inputs: Negotiation_Signal_RemoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remote`)
};

const pl_negotiation_signal_remote = /** @type {(inputs: Negotiation_Signal_RemoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remote`)
};

const fi_negotiation_signal_remote = /** @type {(inputs: Negotiation_Signal_RemoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remote`)
};

const da_negotiation_signal_remote = /** @type {(inputs: Negotiation_Signal_RemoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remote`)
};

const sv_negotiation_signal_remote = /** @type {(inputs: Negotiation_Signal_RemoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remote`)
};

/**
* | output |
* | --- |
* | "Remote" |
*
* @param {Negotiation_Signal_RemoteInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const negotiation_signal_remote = /** @type {((inputs?: Negotiation_Signal_RemoteInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Negotiation_Signal_RemoteInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_negotiation_signal_remote(inputs)
	if (locale === "fr") return fr_negotiation_signal_remote(inputs)
	if (locale === "es") return es_negotiation_signal_remote(inputs)
	if (locale === "it") return it_negotiation_signal_remote(inputs)
	if (locale === "nl") return nl_negotiation_signal_remote(inputs)
	if (locale === "pl") return pl_negotiation_signal_remote(inputs)
	if (locale === "fi") return fi_negotiation_signal_remote(inputs)
	if (locale === "da") return da_negotiation_signal_remote(inputs)
	if (locale === "sv") return sv_negotiation_signal_remote(inputs)
	return en_negotiation_signal_remote(inputs)
});